import request from '@/services/interceptor.js'

export const valida = (par) => {
    return request({
        url: '/timbratura/validate',
        method: 'post',
        data: par,
        loadingBar: false
    })
}

export const getStatus = (par) => {
    return request({
        url: '/timbratura/status',
        method: 'post',
        data: par,
        loadingBar: false
    })
}

export const validaOffline = (data) => {
    return request({
        url: '/timbratura/validate-offline',
        method: 'post',
        data: data,
        loadingBar: false,
        timeout: 10000
    })
}

export const logTimbraturaEvent = (logEntry) => {
    return request({
        url: '/timbratura/log-event',
        method: 'post',
        data: logEntry,
        loadingBar: false
    })
}